import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import Edit from '@material-ui/icons/Edit';
import {Tooltip} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {applyCollectionRowHighlight, applyHighlightFilter, getCollectionHighlightTrProps, getHighlightPkeyFromLocation, syncCollectionFetchPage} from "utilities/avCenterHighlight";

export default class AvUpcomingRenewals extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Av_Upcoming_Renewals._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
		this.state.notesModal = false;
		this.state.noteRow = null;
		this.state.outreachNotes = '';
		this.state.actionError = null;
		this.state.highlightRow = getHighlightPkeyFromLocation(props.history);
		this.rowRefs = {};
	}

	componentDidUpdate(prevProps) {
		if (prevProps.history?.location?.hash !== this.props.history?.location?.hash) {
			const highlightRow = getHighlightPkeyFromLocation(this.props.history);
			this.setState({highlightRow}, () => this.fetchData());
		}
	}

	matchLabel = (row) => {
		if (row.customer && row.av_key) return 'Full match';
		if (row.customer) return 'Customer only';
		return 'Stripe only';
	}

	fetchData = async (state) => {
		syncCollectionFetchPage(this, state);
		if (typeof (this.state.filter) === "undefined" || Array.isArray(this.state.filter)) {
			this.state.filter = {};
		}
		this.state.filter.window = this.props.window || 'all';
		const highlightPkey = applyHighlightFilter(this, this.state.filter);
		this.model.filter = this.state.filter;
		this.setState({loading: true, highlightRow: highlightPkey || this.state.highlightRow});
		window.setTimeout(async () => {
			await this.fetchDataActual(state);
			applyCollectionRowHighlight(this);
		}, 100);
	}

	markContacted = async (row, contacted) => {
		this.setState({ actionError: null });
		try {
			let model = new API.BuildClass(Types.Av_Upcoming_Renewals._name, API.RequestType.UPDATE);
			model.object.pkey = row.pkey;
			model.object.contacted = contacted;
			model.object.outreach_notes = row.outreach_notes ?? '';
			await model.submit(null, 'POST_MARK_CONTACTED');
			await this.fetchData();
		} catch (err) {
			this.setState({ actionError: err?.message || 'Could not update contacted status' });
			await this.fetchData();
		}
	}

	saveNotes = async () => {
		const row = this.state.noteRow;
		if (!row) return;
		this.setState({ actionError: null });
		try {
			let model = new API.BuildClass(Types.Av_Upcoming_Renewals._name, API.RequestType.UPDATE);
			model.object.pkey = row.pkey;
			model.object.outreach_notes = this.state.outreachNotes;
			await model.submit(null, 'POST');
			this.setState({ notesModal: false, noteRow: null, outreachNotes: '' });
			await this.fetchData();
		} catch (err) {
			this.setState({ actionError: err?.message || 'Could not save notes' });
		}
	}

	daysLabel = (row) => {
		const days = row.days_to_expire;
		if (days === null || days === undefined) return '';
		if (days < 0) return `Expired ${Math.abs(days)} day(s) ago`;
		if (days === 0) return 'Expires today';
		return `${days} day(s)`;
	}

	render() {
		const {data, pages, limit, loading, highlightRow} = this.state;
		const isExpired = this.props.window === 'recently_expired';

		const columns = [
			{
				Header: "Customer",
				id: "customer_name",
				accessor: obj => {
					if (obj.customers && obj.customers.name) {
						return obj.customers.name;
					}
					return obj.stripe_customer_id || 'Unknown';
				},
				Cell: (props) => {
					const row = props.original;
					if (row.customer) {
						return (
							<Link to={`/customers/${row.customer}#av-center`}>{props.value}</Link>
						);
					}
					return <span>{props.value}</span>;
				}
			},
			{
				Header: "Product",
				id: 'product_name',
				accessor: obj => obj.product_name,
			},
			{
				Header: isExpired ? "Expired" : "Days to Expire",
				id: 'days_to_expire',
				accessor: obj => this.daysLabel(obj),
			},
			{
				Header: "Period End",
				id: 'period_end',
				accessor: obj => obj.period_end ? moment(obj.period_end).format('MM/DD/YYYY') : '',
			},
			{
				Header: "Stripe Status",
				id: 'stripe_status',
				accessor: obj => obj.stripe_status || 'N/A',
			},
			{
				Header: "Cancel at Period End",
				id: 'cancel_at_period_end',
				accessor: obj => obj.cancel_at_period_end ? 'Yes' : 'No',
			},
			{
				Header: "Contacted",
				id: 'contacted',
				Cell: (props) => (
					<FormControlLabel
						control={
							<Checkbox
								checked={!!props.original.contacted}
								onChange={(e) => this.markContacted(props.original, e.target.checked)}
								color="primary"
							/>
						}
						label={props.original.contacted ? 'Yes' : 'No'}
					/>
				),
			},
			{
				Header: "Notes",
				id: 'outreach_notes',
				accessor: obj => obj.outreach_notes,
				Cell: (props) => (
					<span>
						{props.value || '-'}
						<Tooltip title="Edit outreach notes">
							<Edit
								style={{ marginLeft: 8, cursor: 'pointer' }}
								onClick={() => this.setState({
									notesModal: true,
									noteRow: props.original,
									outreachNotes: props.original.outreach_notes ?? '',
								})}
							/>
						</Tooltip>
					</span>
				),
			},
			{
				Header: "Match",
				id: 'match',
				accessor: obj => this.matchLabel(obj),
			},
		];

		const defaultSort = isExpired
			? [{ id: 'period_end', desc: true }]
			: [{ id: 'days_to_expire', desc: false }];

		return (
			<Card>
				<CardContent>
					{this.state.actionError && (
						<div className="alert alert-danger" role="alert">{this.state.actionError}</div>
					)}
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('AV Subscriptions')}
							{this.renderHeaderRight('AV Subscriptions', columns)}
						</div>
					</div>
					<ReactTable
						key={`${this.state.key}-${this.props.window || 'all'}`}
						columns={columns}
						manual
						data={data}
						pages={pages}
						loading={loading}
						loadingText="Requesting Data"
						onFetchData={this.fetchData}
						defaultSorted={defaultSort}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						onPageChange={this.onPageChange}
						page={this.state.page}
						pageSize={limit}
						getTrProps={getCollectionHighlightTrProps(highlightRow, this.rowRefs)}
					/>
					<Framework.Elements.LoadingSpinner isLoading={loading}/>
					<Modal
						isOpen={this.state.notesModal}
						toggle={() => this.setState({ notesModal: false, noteRow: null })}
						size="lg"
					>
						<ModalHeader toggle={() => this.setState({ notesModal: false })}>Outreach Notes</ModalHeader>
						<ModalBody>
							<TextField
								fullWidth
								multiline
								rows={10}
								value={this.state.outreachNotes}
								onChange={(e) => this.setState({ outreachNotes: e.target.value })}
								variant="outlined"
								label="Notes"
								margin="normal"
								InputLabelProps={{ shrink: true }}
								inputProps={{ style: { minHeight: 220 } }}
							/>
						</ModalBody>
						<ModalFooter>
							<Button color="primary" onClick={this.saveNotes}>Save</Button>
							<Button onClick={() => this.setState({ notesModal: false, noteRow: null })}>Cancel</Button>
						</ModalFooter>
					</Modal>
				</CardContent>
			</Card>
		)
	}
}
